import React, { HTMLAttributes } from 'react';
import IconButton from '../IconButton/IconButton';

interface IProperties extends HTMLAttributes<HTMLButtonElement> {
  hover: boolean;
}

const PreviewPlayButton = ({ hover, ...remainingProperties }: IProperties) => {
  return (
    <IconButton
      {...remainingProperties}
      className={` p-2 shadow-theme-shadow shadow-lg bg-theme-green text-theme-black absolute mr-2 bottom-0 right-0 duration-300 transition-[bottom opacity] outline-offset-[-1px] outline-none hover:outline-theme-light-green hover:outline hover:bg-theme-light-green ${
        hover ? 'bottom-2 opacity-100' : ' opacity-0'
      }`}
      iconClassName="text-3xl"
      icon="play_arrow"
    />
  );
};

export default PreviewPlayButton;
